import React, {cloneElement, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useMutation, useQuery} from "@apollo/react-hooks";
import {DELETE_ACTIVITIES, GET_ACTIVITIES} from "../../database/queries/activityQueries";
import {SizeMe} from "react-sizeme";
import MaterialTable from "material-table";
import tableIcons from "../../constants/tableIcons";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import Moment from "react-moment";
import CalendarStrings from "../../constants/calendarStrings";
import PageBar from "../Common/PageBar";
import {Route, Switch, useHistory, useRouteMatch, Link} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
}));

// const getActivityType = value => {
//     switch (value) {
//         case 'call':
//             return 'Call';
//         case 'email':
//             return 'Email';
//         case 'text':
//             return "Text Message";
//         default:
//             return "Unknown";
//     }
// };
//
// const getActivityStatus = value => {
//     switch (value) {
//         case 'not_started':
//             return 'Not Started';
//         case 'in_progress':
//             return 'In Progress';
//         case 'on_hold':
//             return "On Hold";
//         case 'completed':
//             return "Completed";
//         case 'cancelled':
//             return "Cancelled";
//         default:
//             return "Unknown";
//     }
// };

const ActivityList = props => {
    const classes = useStyles();
    const [searchStr, setSearchStr] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [activities, setActivities] = useState(null);
    const [globalLayoutState] = useLayoutStore();
    let {url} = useRouteMatch();
    const history = useHistory();

    let columns = [
        {
            title: 'Name',
            width: '34%',
            render: r => {
                return (
                    <Link to={`${url}/${r.activityId}`}>
                        {r.activityName}
                    </Link>
                );
            },
        },
        {title: 'Description', field: 'activityDescription', width: '42%',},
        {title: 'Type', field: 'activityType', width: '8%',},
        {title: 'Status', field: 'activityStatus', width: '8%',},
        {
            title: 'Started',
            render: r => <Moment calendar={CalendarStrings}>{r.startedAt}</Moment>,
            width: '8%',
        },
        {
            title: 'Ended',
            render: r => <Moment calendar={CalendarStrings}>{r.endedAt}</Moment>,
            width: '8%',
        },
    ];

    if (!props.parentType) {
        columns = [
            {
                title: 'Name',
                width: '20%',
                render: r => {
                    return (
                        <Link to={`${url}/${r.activityId}`}>
                            {r.activityName}
                        </Link>
                    );
                },
            },
            {title: 'Entity Type', field: 'entityType', width: '16%',},
            {title: 'Entity Name', field: 'entityName', width: '16%',},
            {
                title: 'Share',
                width: '16%',
                render: r => {
                    if (r.team) {
                        return <span>{r.team.teamName}</span>
                    } else if (r.integration) {
                        return <span>{r.integration.integrationName}</span>
                    } else {
                        return <span>Personal</span>
                    }
                },
            },
            {title: 'Type', field: 'activityType', width: '8%',},
            {title: 'Status', field: 'activityStatus', width: '8%',},
            {
                title: 'Started',
                render: r => <Moment calendar={CalendarStrings}>{r.startedAt}</Moment>,
                width: '8%',
            },
            {
                title: 'Ended',
                render: r => <Moment calendar={CalendarStrings}>{r.endedAt}</Moment>,
                width: '8%',
            },
        ];
    }

    const {loading: getActivitiesLoading, error: getActivitiesError, data: getActivitiesData, refetch: getActivitiesRefetch} = useQuery(GET_ACTIVITIES, {
        variables: {
            parentType: props.editType ? props.editType : null,
            parentId: props.editId ? props.editId : null,
            shareCategoryType: props.shareCategoryType ? props.shareCategoryType : 'personal',
            shareCategoryId: props.shareCategoryId ? props.shareCategoryId : 'personal',
            searchStr: searchStr,
            // limit: 10,
            // offset: 0,
            orderList: ['updatedAt DESC']
        },
    });

    const [deleteActivities, {error: deleteActivitiesError}] = useMutation(DELETE_ACTIVITIES);

    const handleSearch = (s) => {
        setSearchStr(s);
        getActivitiesRefetch();
    };

    const handleRefresh = () => {
        getActivitiesRefetch();
    };

    const handleDelete = () => {
        const selectedIds = selectedRows.map(row => row.activityId);
        deleteActivities({
            variables: {deleteActivityIds: selectedIds}
        }).then(deleteActivitiesResult => {
            if (deleteActivitiesResult.data.deleteActivities.returnCode === 0) {
                notify('deleteActivities', 'info', deleteActivitiesResult.data.deleteActivities.message);
            } else {
                notify('deleteActivities', 'error', deleteActivitiesResult.data.deleteActivities.message);
            }
            getActivitiesRefetch();
        }).catch(e => {
            notify('deleteActivities', 'error', e.message);
            getActivitiesRefetch();
        })
    };

    useEffect(() => {
        getActivitiesRefetch();
    }, [getActivitiesRefetch]);

    useEffect(() => {
        if (deleteActivitiesError) notify('deleteActivitiesError', 'error', deleteActivitiesError.message);
        if (getActivitiesError) notify('getActivitiesError', 'error', getActivitiesError.message);
    }, [deleteActivitiesError, getActivitiesError]);

    useEffect(() => {
        if (getActivitiesData && getActivitiesData.activities) {
            let myActivities = [];
            getActivitiesData.activities.map(activity => {
                let myActivity = {...activity};
                if (myActivity.account) {
                    myActivity.entityType = 'Account';
                    myActivity.entityName = myActivity.account.accountName;
                } else if (myActivity.contact) {
                    myActivity.entityType = 'Contact';
                    myActivity.entityName = myActivity.contact.contactLastFirstName;
                } else if (myActivity.project) {
                    myActivity.entityType = 'Project';
                    myActivity.entityName = myActivity.project.projectName;
                } else {
                    myActivity.entityType = 'General';
                }
                myActivities.push(myActivity);
                return myActivity;
            });
            setSelectedRows([]);
            setSelectedObj({});
            setActivities(myActivities);
        }
    }, [getActivitiesData]);

    useEffect(() => {
    }, []);

    return (
        <Switch>
            <Route exact path={`${url}`}>
                <PageBar
                    title={(props.shareCategoryName ? props.shareCategoryName + ' ' : '') + (props.parentName ? props.parentName + ' ' : '') + 'Activities'}
                    handleSearch={handleSearch}
                    handleRefresh={handleRefresh}
                    handleAdd={() => {
                        console.log('## SVR activityList ## changing history', `${url}/new`);
                        history.push(`${url}/new`);
                    }}
                    handleEdit={() => {
                        console.log('## SVR activityList ## changing history', `${url}/${selectedObj.activityId}`);
                        history.push(`${url}/${selectedObj.activityId}`);
                    }}
                    editDisabled={selectedRows.length !== 1}
                    tagDisabled={selectedRows.length === 0}
                    handleDelete={handleDelete}
                    deleteDisabled={selectedRows.length === 0}
                    exportDisabled={selectedRows.length === 0}
                    showLoading={getActivitiesLoading}
                >
                </PageBar>
                <div className={classes.root}>
                    {activities && (
                        <SizeMe>
                            {({size}) => {
                                let height = size.height;
                                if (!height) height = window.innerHeight;

                                const tableOptions = {
                                    actionsColumnIndex: -1,
                                    header: true,
                                    maxBodyHeight: height - (globalLayoutState.tabBarHeight + 250),
                                    padding: 'dense',
                                    paging: false,
                                    selection: true,
                                    selectionProps: r => ({
                                        name: r.activityName.replace(/\s+/g, '-').toLowerCase() === '___test' ? 'checkTest' : ''
                                    }),
                                    toolbar: false,
                                };

                                return (
                                    <MaterialTable
                                        columns={columns}
                                        data={activities}
                                        icons={tableIcons}
                                        options={tableOptions}
                                        onSearchChange={(str) => {
                                            setSearchStr(str);
                                        }}
                                        onSelectionChange={(rows) => {
                                            setSelectedRows(rows);
                                            if (rows.length === 1) {
                                                setSelectedObj({id: rows[0].activityId, name: rows[0].activityName})
                                            } else {
                                                setSelectedObj({})
                                            }
                                        }}
                                    />
                                );
                            }}
                        </SizeMe>
                    )}
                </div>
            </Route>
            <Route path={`${url}/:editId`}>
                {cloneElement(props.parent.routes.edit.component, {
                    ...props,
                    parentEditType: props.editType,
                    parentEditId: props.editId,
                    parentRefresh: () => {
                        getActivitiesRefetch()
                    },
                    editType: 'activity',
                    parent: props.parent.routes.edit
                })}
            </Route>
        </Switch>
    )
};

export default ActivityList;
